const ClockingNotesModal = ({ closeModal, note, setNote, buttonLogic, buttonText, showPPEQuestion = false, hasPPE = null, setHasPPE }) => {
	return (
		<div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black/[.3] z-[200]" onClick={closeModal}>
			<div
				className="p-4 bg-white rounded-lg w-full md:w-2/5"
				onClick={(e) => {
					e.stopPropagation();
				}}>
				<p className="font-bold text-center text-xl mb-4">{showPPEQuestion ? "Meal In" : "Add Note (optional)"}</p>
				{showPPEQuestion ? (
					<div className="mb-4">
						<label className="block font-semibold mb-2">Do you have your PPE?</label>
						<div className="flex space-x-4">
							<label className="flex items-center">
								<input type="radio" name="mealin-ppe" value="yes" checked={hasPPE === true} onChange={() => setHasPPE?.(true)} />
								<span className="ml-2">Yes</span>
							</label>
							<label className="flex items-center">
								<input type="radio" name="mealin-ppe" value="no" checked={hasPPE === false} onChange={() => setHasPPE?.(false)} />
								<span className="ml-2">No</span>
							</label>
						</div>
						{hasPPE === false ? (
							<p className="text-red-500 mt-2">
								Warning: You may not clock into a job site without PPE. Contact your ops manager for the next steps.
							</p>
						) : null}
					</div>
				) : null}
				<p className="font-bold text-center text-xl mb-4">Add Note (optional)</p>
				<div>
					<textarea
						value={note}
						onChange={(e) => setNote(e.target.value)}
						placeholder=""
						rows="4"
						className="w-full p-1 border border-black"
						maxLength={500}
					/>
					<div className="text-xs float-right">{`${note.length}/500`}</div>
				</div>
				<button
					type="button"
					className={`w-full p-2 mt-3 rounded ${showPPEQuestion && typeof hasPPE !== "boolean" ? "bg-gray-500 text-white cursor-not-allowed" : "bg-blue-500 text-white"}`}
					onClick={buttonLogic}
					disabled={showPPEQuestion && typeof hasPPE !== "boolean"}>
					{buttonText}
				</button>
			</div>
		</div>
	);
};

export default ClockingNotesModal;
